import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Autocomplete,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDBox from "components/MDBox";
import FormField from "components/FormField";

const CooperatedFormContacts = ({ label, cooperated, contactType, setContactType, setInput }) => {
  const [step, setStep] = useState(false);

  const [inputValueContactType, setInputValueContactType] = useState("");

  const optionsContact = ["Whatsapp", "Ligação", "Presencial", "E-mail"];

  const contactTypeString = (cntt) => {
    switch (cntt) {
      case 1:
        return "Whatsapp";
      case 2:
        return "Ligação";
      case 3:
        return "Presencial";
      case 4:
        return "E-mail";
      default:
        return cntt;
    }
  };

  return (
    <Accordion
      expanded={step}
      onChange={() => setStep(!step)}
      slotProps={{ transition: { timeout: 400 } }}
      sx={{
        "& .MuiAccordion-region": {
          height: step ? "auto" : 0,
        },
        "& .MuiAccordionDetails-root": {
          display: step ? "block" : "none",
        },
      }}
    >
      <MDBox p={3}>
        <MDBox>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography>{label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MDBox mt={1.625}>
              <FormField
                type="text"
                label="Celular"
                name="phone"
                value={cooperated?.phone}
                mask="phoneBR"
                placeholder="Celular"
                onChange={setInput}
                required
              />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    value={contactTypeString(
                      contactType ?? cooperated?.contact_type
                    )}
                    onChange={(_, newValue) => {
                      setContactType(newValue);
                    }}
                    inputValue={inputValueContactType}
                    onInputChange={(_, newInputValue) => {
                      setInputValueContactType(newInputValue);
                    }}
                    options={optionsContact}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Forma de contato"
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type="text"
                    label="Contato"
                    name="contact"
                    value={cooperated?.contact}
                    placeholder="Contato"
                    onChange={setInput}
                    required
                  />
                </Grid>
              </Grid>
            </MDBox>
          </AccordionDetails>
        </MDBox>
      </MDBox>
    </Accordion>
  );
};

export default CooperatedFormContacts;
